import baseFetch, { createParamString } from '../baseFetch';
import { getMeterParamsForRequest } from '../../utils/meteringHelper';

export const fetchRegionalOverview = (subregionId, cookies, meter) => {
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(
    `/kbyg/regions/overview?subregionId=${subregionId}&meterRemaining=${meterRemaining}`,
    {
      cookies,
      ...meterHeaders,
    },
  );
};

export const fetchNearbySubregions = (subregionId, cookies, meter) => {
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(
    `/kbyg/regions/nearby?subregionId=${subregionId}&meterRemaining=${meterRemaining}`,
    { cookies, ...meterHeaders },
  );
};

export const fetchRegionalArticles = async (subregionId, cookies) =>
  baseFetch(`/feed/regional?${createParamString({ subregionId })}`, { cookies });
